<template>
    <div class="d-flex flex-column mt-6">
        <div>
            <div class="p-4">
                <h5 class="text-center font-weight-bold">About HiRO</h5>
                <p class="text-center text-secondary">
                    {{t("The First Full-on Health Record Generating System")}}
                </p>

            </div>

            <div class="p-4 bg-light-skyler">
                <div class="d-flex align-items-center mb-2">
                    <i-letter class="mx-2" width="2.5em" height="2.5em"></i-letter>

                    <div class="font-weight-bold">
                        <a target="_blank" href="mailto:info@hiro-health.com">
                            info@hiro-health.com
                        </a>
                    </div>
                </div>

                <div class="d-flex align-items-center">
                    <i-globe class="mx-2" width="2.5em" height="2.5em"></i-globe>

                    <div class="font-weight-bold">
                        <a href="https://hiro-health.com" target="_blank">
                            www.hiro-health.com
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-grow-1 justify-content-around align-items-center">
            <!--            <a target="_blank" href="https://www.facebook.com/myHirohealth/">-->
            <!--                <b-img rounded :src="require('../../assets/img/social-media/facebook.svg')"></b-img>-->
            <!--            </a>-->

            <!--            <a target="_blank" href="https://www.instagram.com/hiro_health/">-->
            <!--                <b-img rounded :src="require('../../assets/img/social-media/instagram.svg')"></b-img>-->
            <!--            </a>-->

            <!--            <a target="_blank" href="https://www.linkedin.com/company/hiro-healthcare">-->
            <!--                <b-img rounded :src="require('../../assets/img/social-media/linked-in.svg')"></b-img>-->
            <!--            </a>-->

            <div>
                Powered by <a href="https://www.tradinos.com">Tradinos</a>
            </div>
        </div>
    </div>
</template>

<script>
    import ILetter from "../../components/Icons/ILetter";
    import IGlobe from "../../components/Icons/IGlobe";

    export default {
        name: "AboutUs",
        components: {
            ILetter,
            IGlobe
        }
    }
</script>

<style scoped>

</style>
